import { Devices } from "../../DeviceAdapter";
export class UnknownAudioEffectDeviceBoxAdapter {
    type = "audio-effect";
    accepts = "audio";
    #context;
    #box;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get indexField() { return this.#box.index; }
    get labelField() { return this.#box.label; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get host() { return this.#box.host; }
    get commentField() { return this.#box.comment; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { }
}
